module.exports = __webpack_public_path__ + "img/5b6a6724a2029eba7684d7bf6da118e4.png";